<template>
  <div @click.self="closeModal" class="modalContainer">
    <div class="modalWrapper">
      <div @click="closeModal" class="close">
        <img src="@/assets/icons/close.svg" alt="close" />
      </div>
      <h2 style="text-align: center">There is a problem with your order</h2>
      <Markdown :source="errorMessages" style="text-align: center" />
      <button @click="closeModal">OK</button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Markdown from 'vue3-markdown-it'

import modalMixins from '@/mixins/modalMixins.js'

export default {
  data() {
    return {
      error: {
        status: false,
        message: '',
      },
    }
  },
  props: ['address', 'addressIndex'],
  components: {
    Markdown,
  },
  mixins: [modalMixins],
  computed: {
    ...mapState(['orderData']),
    errorMessages() {
      let errors = this.orderData.order.errors
      let errorCount = Object.keys(errors).length
      let errorString = ''
      if (errorCount > 1) {
        for (let errorKey in errors) {
          errorString += '•' + errors[errorKey] + '\n'
        }
      } else if (errorCount === 1) {
        for (let errorKey in errors) {
          errorString += errors[errorKey]
        }
      }
      return errorString
    },
  },
  methods: {
    closeModal() {
      this.$emit('closeModal')
      this.$emit('confirmedGenericError')
    },
  },
}
</script>

<style src="../../../assets/css/Modals/StoreModals/GenericErrorModal.css" scoped></style>
